import { AudienceVolumeSectorTypes } from '../types'

/**
 * trieda pre spravu konstant pre audio
 */
export const audioGameConfig = {

  /** aku minimalnu hlasitost maju divaci */
  minAudienceSound: 0.2,

  /** ako dlho trva dostat sa na minimalny zvuk */
  minAudienceDuration: 5,

  /** aku maximalnu hlasitost maju divaci */
  maxAudienceSound: 1,

  /** ako dlho trva dostat sa na maximalny zvuk */
  maxAudienceDuration: 3,

  /** kedy dychcat srdce pri behu */
  breathingRunningTreshold: 160,

  /** ako zvysujeme hlasitost divakov */
  finishAudienceIncreaseVolume: {

    /** ako casto */
    frames: 3,

    /** o kolko */
    step: 0.1

  },

  /** Ake typy sektorov znamenaju postupne menenie hlasitosti */
  audienceVolumeSectorTypesGradually: [
    AudienceVolumeSectorTypes.graduallyDecrease,
    AudienceVolumeSectorTypes.graduallyIncrease
  ]

}
